import { asAbsoluteApiUrl, prefixedWithSlash } from "./functions";

export type ApplicationUrl = {
  uiPath: string;
  apiUrl: string;
};

export const applicationUrl = (config: {
  relativeUrl: string;
  relativeApiUrl?: string;
}): ApplicationUrl => ({
  uiPath: prefixedWithSlash(config.relativeUrl),
  apiUrl: asAbsoluteApiUrl(
    config.relativeApiUrl ? config.relativeApiUrl : config.relativeUrl
  ),
});

export type UrlWithParams<T> = (urlParams: T) => string;

export const uiPathWithParams =
  <T>(createRelativeUrl: UrlWithParams<T>): UrlWithParams<T> =>
  (urlParams: T) =>
    prefixedWithSlash(createRelativeUrl(urlParams));

export const apiUrlWithParams =
  <T>(createRelativeUrl: UrlWithParams<T>): UrlWithParams<T> =>
  (urlParams: T) =>
    asAbsoluteApiUrl(createRelativeUrl(urlParams));

export const urlWithParams =
  <T>(
    createRelativeUrl: UrlWithParams<T>
  ): ((urlParams: T) => ApplicationUrl) =>
  (urlParams: T) => ({
    uiPath: uiPathWithParams(createRelativeUrl)(urlParams),
    apiUrl: apiUrlWithParams(createRelativeUrl)(urlParams),
  });
